
import React from "react";
import { Button } from "antd";
import "./NextStepBtnComponent.scss";

import { INextStepBtnComponentProps } from "./NextStepBtnInterfaces.types";
import { useNavigate } from "react-router-dom";
import { StorageInterface } from "store/StorageInterface";
import { useSelector } from "react-redux";
import userDataService from "store/UserData/UserDataService";

function NextStepBtnComponent(props: INextStepBtnComponentProps) {
  const userData = useSelector((state: StorageInterface) => {
    return state.userDataSlice;
  });
  let navigate = useNavigate();

  const saveUserOptionSelected = (option: any) => {
    const fullName = userData.fullname || 'Desconocido';
    const email = userData.email || 'omitiopaso@incognito.cl';
    let queryParams = {
      email,
      params: [
        {
          name: "TRANS_SIM_USER_FULLNAME",
          value: `${fullName}`,
        },
        {
          name: "TRANS_SIM_USER_SELECTION",
          value: `${option}`,
        },
      ],
    };
    userDataService.saveUserData(queryParams);
    sendBrevoUserData(fullName, email, Number(props.userOptionSelected?.value));
    let addRoleToData = {
      fullname: userData.fullname,
      email: userData.email,
      role: props.userOptionSelected
        ? Number(props.userOptionSelected?.value) === 2
          ? "seller"
          : "buyer"
        : "seller",
    };
    //adding selected btn options for user role, to slice
    userDataService.setUserData(addRoleToData);
  };

  const sendBrevoUserData = (name: string, email: string, userOptionSelected: number) => {
    const contentId = userOptionSelected === 1 ? 'simulador_trf_perfil_comprar' : (
      userOptionSelected === 2 ? 'simulador_trf_perfil_vender' : 'simulador_trf_perfil_conocer'
    );
    let data = {
      name,
      email,
      body: {
        email,
        event: 'select_content',
        properties: {
          gtmEvent: 'select_content',
          itemname: '152717',
          plate: 'BBBB11',
          name: name.toUpperCase(),
          productSlug: 'transferencia-estandar',
          content_name: 'simulador_trf',
          content_phase: 'paso_2_opciones',
          content_id: contentId, 
        },
      },
    };

    userDataService.sendBrevoUserData(data);
  };

  const navigateTo = () => {
    let path = props.value;
    navigate(path);

    /* Saving user data and selected option,if selection was executed when user select new option
      props.userOptionSelected take text value */
    if (props.userOptionSelected && props.userOptionSelected !== undefined) {
      saveUserOptionSelected(props.userOptionSelected.text);
    }
  };

  return (
    <div className={`NextStepBtn ${props.className}`}>
      <Button
        id={props.id || ""}
        value={props.value}
        disabled={props.disabled}
        className={`btn  ${props.btnClassName}`}
        onClick={navigateTo}
        block={true}
      >
        {props.text}
      </Button>
    </div>
  );
}

NextStepBtnComponent.defaultProps = {
  text: "Siguiente",
  className: "",
  btnClassName: "",
};

export default NextStepBtnComponent;
